/**
 * Portal transition links — global.
 *
 * Plain script (no bundler). Loaded from theme.liquid on EVERY page (after the
 * GSAP libs) so any `<a data-portal-link>` works site-wide — the header, which
 * appears on every page, relies on this being global (scene.js only loads where
 * the Scene section is present).
 *
 * Instead of a hard navigation, fade the global exit overlay up to the
 * transition colour, then navigate. The destination hero's first paint is that
 * same colour (closed arch veil) and its portal opens on load — so the hand-off
 * reads as one continuous "grow → opaque → dissolve into the hero", with no
 * white navigation flash.
 */
(function () {
  if (window.__tamrePortalLinks) return;
  window.__tamrePortalLinks = true;

  function isStaticMode() {
    return (
      window.matchMedia('(prefers-reduced-motion: reduce)').matches ||
      !!(window.Shopify && window.Shopify.designMode)
    );
  }

  function bindPortalLinks() {
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[data-portal-link]');
      if (!a) return;
      // Let modified / non-primary clicks (new tab, etc.) and the editor behave
      // natively; in static mode there's no transition to play.
      if (
        e.defaultPrevented ||
        e.button !== 0 ||
        e.metaKey ||
        e.ctrlKey ||
        e.shiftKey ||
        e.altKey ||
        isStaticMode()
      ) {
        return;
      }
      var href = a.getAttribute('href');
      if (!href || href === '#') return;

      e.preventDefault();
      try {
        sessionStorage.setItem('tamre:portal', '1');
      } catch (err) {}
      if (window.lenis) window.lenis.stop();

      // Fade the ambient music out with the visuals, so it doesn't cut abruptly
      // when the page unloads. (The audio only lives on this page; the next page
      // starts silent.) Runs alongside the overlay fade below.
      if (window.gsap && window.tamreAudio && window.tamreAudio.isPlaying()) {
        gsap.to(window.tamreAudio.el, { volume: 0, duration: 0.45, ease: 'power1.inOut' });
      }

      // Without the overlay or GSAP there's nothing to fade — just navigate.
      var overlay = document.querySelector('[data-portal-exit]');
      if (!overlay || !window.gsap) {
        window.location.assign(href);
        return;
      }
      var col = a.getAttribute('data-portal-color');
      if (col) overlay.style.backgroundColor = col;
      gsap.to(overlay, {
        autoAlpha: 1,
        duration: 0.45,
        ease: 'power1.inOut',
        onComplete: function () {
          window.location.assign(href);
        }
      });
    });
  }

  // Bind immediately so no early click is missed. The handler reads window.gsap
  // at click time and falls back to a plain navigation if it isn't ready yet.
  bindPortalLinks();
})();
